import React, { useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import useAxiosPartnerPortal from 'gatsby-theme-kn/src/hooks/useAxiosPartnerPortal'
import { apiURL, isAdmin } from 'gatsby-theme-kn/src/utils/partner_portal_spa'
import LoadingSpinner from 'gatsby-theme-kn/src/components/modules/LoadingSpinner'
import Image from 'gatsby-theme-kn/src/components/atoms/Image'

const ModalMediaDatabase = ({
  uploadPath,
  titleSetter,
  iconSetter,
  closeModal,
  addRoutingAttribute,
}) => {
  const { t } = useTranslation()
  const { data, loading, error } = useAxiosPartnerPortal(
    apiURL(uploadPath),
    {},
    'get'
  )

  const [uploadType, setUploadType] = useState(null)

  useEffect(() => {
    if (data) {
      titleSetter(data.title)
      iconSetter('fal ' + getFileIconClassFromExtension(data.filetype))
      setUploadType(getFileTypeFromExtension(data.filetype))
    }
  }, [data])

  function getFileExtension(ext) {
    return (ext || '').split('.').pop().toLowerCase()
  }
  function getFileIconClassFromExtension(ext) {
    var ext = (getFileExtension(ext) || '').split('.').pop().toLowerCase()
    return {
      svg: 'fa-file-image',
      ai: 'fa-file-image',
      eps: 'fa-file-image',
      png: 'fa-file-image',
      jpg: 'fa-file-image',
      jpeg: 'fa-file-image',
      gif: 'fa-file-image',
      tiff: 'fa-file-image',
      tif: 'fa-file-image',
      pdf: 'fa-file-pdf',
      txt: 'fa-file-alt',
      doc: 'fa-file-word',
      docx: 'fa-file-word',
    }[ext]
  }
  function getFileTypeFromExtension(ext) {
    var ext = (getFileExtension(ext) || '').split('.').pop().toLowerCase()
    return {
      eps: 'vector',
      svg: 'vector',
      ai: 'vector',
      png: 'image',
      jpg: 'image',
      jpeg: 'image',
      gif: 'image',
      tiff: 'image',
      tif: 'image',
      pdf: 'document',
      txt: 'document',
      doc: 'nopreview-document',
      docx: 'nopreview-document',
      zip: 'nopreview-document',
    }[ext]
  }

  // Die Transformations werden per Regex in die URL gegeben
  const downloadUrl = (url, transformations) => {
    let regex =
      /(https:\/\/res\.cloudinary\.com\/koenig-neurath\/images\/)([^/]+)\/(.+)/
    let match = url && url.match(regex)
    if (match) {
      return `${match[1]}${transformations}/${match[2]}/${match[3]}`
    }
    return url
  }

  return (
    <div className="media-detail">
      <div className="media-detail-basics">
        {loading && <LoadingSpinner />}
        <dl className="row">
          {data?.filetype !== 'nopreview-document' && (
            <>
              <dt className="col-sm-3">
                {t('generic.spa.media.show.preview')}
              </dt>
              <dd className="col-sm-9">
                <div className="media-detail-img">
                  {data?.urls.original && (
                    <Image
                      image={data?.urls.original}
                      className="img-fluid"
                      imageHeight="300"
                      imageWidth="auto"
                      title={data?.title}
                      alt={data?.title}
                    />
                  )}
                </div>
              </dd>
            </>
          )}
          <dt className="col-sm-3">{t('generic.spa.media.show.downloads')}</dt>
          <dd className="col-sm-9">
            <div className="media-detail-downloads">
              {uploadType && uploadType === 'vector' && (
                <>
                  <a href={data?.urls.original} download={data?.title}>
                    {t('generic.spa.media.show.original')}
                  </a>
                  <br />
                  <a href="#">{t('generic.spa.media.show.office_rgb_png')}</a>
                  <br />
                  <a href="#">{t('generic.spa.media.show.internet_rgb_png')}</a>
                </>
              )}
              {uploadType && uploadType === 'image' && (
                <>
                  {data?.urls.alternative !== '' &&
                    data?.urls.alternative !== null && (
                      <a
                        href={data?.urls.alternative}
                        target="_blank"
                        className="trackable"
                        id={data?.id}
                      >
                        {t('generic.spa.media.show.open_external')}
                      </a>
                    )}
                  {(data?.urls.alternative == '' ||
                    data?.urls.alternative == null) && (
                    <>
                      {data?.urls.webviewer && (
                        <a href={`"upload_webviewer/$(data?.id)"`} data-navigo>
                          {t('generic.spa.media.show.open_external')}
                        </a>
                      )}
                      {!data?.urls.webviewer && (
                        <>
                          <a
                            href={downloadUrl(
                              data?.urls.original,
                              'cs_cmyk,dn_300,fl_attachment'
                            )}
                          >
                            {t('generic.spa.media.show.hires_cmyk')}
                          </a>
                          <br />
                          <a
                            href={downloadUrl(
                              data?.urls.original,
                              'cs_no_cmyk,dn_300,fl_attachment'
                            )}
                          >
                            {t('generic.spa.media.show.hires_rgb')}
                          </a>
                          <br />
                          <a
                            href={downloadUrl(
                              data?.urls.original,
                              'cs_no_cmyk,dn_150,w_0.5,fl_attachment'
                            )}
                          >
                            {t('generic.spa.media.show.office_rgb')}
                          </a>
                          <br />
                          <a
                            href={downloadUrl(
                              data?.urls.original,
                              'cs_no_cmyk,dn_72,w_0.25,fl_attachment'
                            )}
                          >
                            {t('generic.spa.media.show.internet_rgb')}
                          </a>
                        </>
                      )}
                    </>
                  )}
                </>
              )}

              {uploadType && uploadType === 'document' && (
                <>
                  <a href={data?.urls.original} download={data?.title}>
                    {t('generic.spa.media.show.original')}
                  </a>
                  <br />
                  <a href={data?.urls.thumbnail} download={data?.title}>
                    {t('generic.spa.media.show.doc_preview')}
                  </a>
                </>
              )}

              {uploadType && uploadType === 'nopreview-document' && (
                <>
                  <a href={data?.urls.original} download={data?.title}>
                    {t('generic.spa.media.show.original')}
                  </a>
                </>
              )}
            </div>
          </dd>

          {(data?.urls.alternative == '' || data?.urls.alternative == null) && (
            <>
              <dt className="col-sm-3">
                {t('generic.spa.media.show.fileextension')}
              </dt>
              <dd className="col-sm-9">
                <span>
                  <i
                    className={`fal ${getFileIconClassFromExtension(
                      data?.filetype
                    )}`}
                  ></i>
                  &nbsp;
                  {data?.filetype}
                </span>
              </dd>
            </>
          )}
          <dt className="col-sm-3">{t('generic.spa.media.show.filetype')}</dt>
          <dd className="col-sm-9">
            <a
              href="#"
              onClick={(e) => {
                e.preventDefault()
                addRoutingAttribute('upload_category', data?.upload_category.id)
                closeModal()
              }}
            >
              {data?.upload_category.title}
            </a>
          </dd>
          <dt className="col-sm-3">{t('generic.spa.media.show.category')}</dt>
          <dd className="col-sm-9">
            {data?.categories.map((c, index) => (
              <a
                key={index}
                href="#"
                onClick={(e) => {
                  e.preventDefault()
                  addRoutingAttribute('category', c.id)
                  closeModal()
                }}
              >
                {c.title}
                {index !== data?.categories.length - 1 && <span>,</span>}
                &nbsp;
              </a>
            ))}
          </dd>
          {isAdmin() && (
            <>
              <dt className="col-sm-3">{t('generic.spa.media.show.links')}</dt>
              <dd className="col-sm-9">
                <div className="media-detail-links">
                  <div className="input-group mb-1">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ width: '8rem' }}
                      >
                        {t('generic.spa.media.show.original')}
                      </span>
                    </div>
                    <input
                      className="form-control"
                      id="link-original"
                      readOnly
                      defaultValue={data?.urls.original}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        data-clipboard-target="#link-original"
                        title={t('generic.spa.media.show.copy_to_clipboard')}
                      >
                        <i className="fal fa-copy"></i>
                      </button>
                    </div>
                  </div>
                  <div className="input-group mb-1">
                    <div className="input-group-prepend">
                      <span
                        className="input-group-text"
                        style={{ width: '8rem' }}
                      >
                        {t('generic.spa.media.show.preview')}
                      </span>
                    </div>
                    <input
                      className="form-control"
                      id="link-thumbnail"
                      readOnly
                      defaultValue={data?.urls.thumbnail}
                    />
                    <div className="input-group-append">
                      <button
                        className="btn btn-outline-secondary"
                        data-clipboard-target="#link-thumbnail"
                        title={t('generic.spa.media.show.copy_to_clipboard')}
                      >
                        <i className="fal fa-copy"></i>
                      </button>
                    </div>
                  </div>
                </div>
              </dd>
            </>
          )}
        </dl>
      </div>
    </div>
  )
  // return <pre>{JSON.stringify(data, null, 2)}</pre>
}

export default ModalMediaDatabase
